$('.ttb-slider-wrapper').slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    slidesToShow: 1.6,
    slidesToScroll: 1,
    infinite: true,
    vertical: true,
    pauseOnHover: false,
    swipe: false,
    draggable: false,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.2
            }
        }
    ]
});

$('.btt-slider-wrapper').slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    slidesToShow: 1.6,
    slidesToScroll: 1,
    infinite: true,
    vertical: true,
    pauseOnHover: false,
    swipe: false,
    draggable: false,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1.2
            }
        }
    ]
});

document.addEventListener("input", (e) => {
    if (e.target.matches(".select-img-size-wrap input[type='range']")) {
        const el = e.target;
        const percent = ((el.value - el.min) / (el.max - el.min)) * 100;
        el.style.setProperty("--value-percent", percent);
    }
});